import React from 'react';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import FileInput from '../../Shared/UI/FileInput/components/FileInput';

import {
  useEventState,
  useEventActions,
} from './EventContext';

import styles from './EventMainImage.module.scss';

const EventMainImage = () => {
  const state = useEventState();
  const { updateImageAndImageFileName } = useEventActions();

  const handleFileChange = (e) => {
    const image = e.target.files[0];
    if (!image) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result
        .replace("data", "")
        .replace(/^.+,/, "");

      updateImageAndImageFileName(base64String, image.name);
    };

    reader.readAsDataURL(image);
  };

  const presentationMode = () => {
    return (
      <div id={styles.imageContainer}>
        <img className={styles.img} src={state?.event?.imagePath} />
      </div>
    );
  };

  const editMode = () => {
    return (
      <Form>
        <div id={styles.imageContainer}>
          {state?.event?.image && (
            <img className={styles.img} src={`data:image/gif;base64,${state.event.image}`} />
          )}
        </div>
        <Field label="Event Image">
          <FileInput
            accept="image/png,image/gif,image/jpeg"
            onChange={handleFileChange}
          />
        </Field>
      </Form>
    );
  };

  return (
    <div className={styles.event}>
      {state?.inEditMode ?
        (
          editMode()
        ) : (
          presentationMode()
        )
      }
    </div>
  );
};

export default EventMainImage;
